import { css, SerializedStyles } from '@emotion/core'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

import { HippoVideoPopup } from './HippoVideoPopup'
import Image from './Image'
import SvgIcon from './SvgIcon'
import { imageOverlayStyle } from './TextCardContent'
import YoutubeVideoPopup from './YoutubeVideoPopup'

interface VideoPopupProps {
  video: {
    imageSrc?: string
    imageAlt?: string
    gatsbyImageSrc?: any
    youTubeId?: string
    hippoVideoId?: string
    videoUrl?: string
  }
  className?: string
  withPlayButton?: boolean
  withImageOverlay?: boolean
  cssStyles?: SerializedStyles
}

const VideoPopup: React.FunctionComponent<VideoPopupProps> = ({
  video: { imageSrc, imageAlt, gatsbyImageSrc, videoUrl, youTubeId, hippoVideoId },
  className,
  withPlayButton = true,
  withImageOverlay = true,
  cssStyles,
}) => {
  const [showModal, setShowModal] = React.useState(false)
  const onClick = () => {
    setShowModal(true)
    document.body.style.overflow = 'hidden'
  }

  return (
    <div className={className} css={[videoPopupContainerStyle, cssStyles]}>
      <div onClick={onClick}>
        {imageSrc && <Image src={imageSrc} alt={imageAlt || 'Overlay image for video popup'} />}
        {gatsbyImageSrc && (
          <GatsbyImage image={gatsbyImageSrc.gatsbyImageData} alt={imageAlt || 'Overlay image for video popup'} />
        )}
      </div>
      {withPlayButton && <SvgIcon id="icon-above-image" src="abstract/play-button" />}
      {withImageOverlay ? <div css={imageOverlayStyle} onClick={onClick} /> : undefined}
      {youTubeId && !videoUrl && (
        <YoutubeVideoPopup showModal={showModal} setShowModal={setShowModal} selectedVideo={youTubeId} />
      )}
      {hippoVideoId && !videoUrl && (
        <HippoVideoPopup showModal={showModal} setShowModal={setShowModal} hippoVideoId={hippoVideoId} />
      )}
    </div>
  )
}

export default VideoPopup

const videoPopupContainerStyle = css`
  position: relative;
  height: 100%;
  aspect-ratio: 16 / 9;

  #icon-above-image {
    transition: all 0.3s ease-out;
    position: absolute;
    left: calc(50% - 11px);
    top: calc(50% - 11px);
    z-index: 2;
    pointer-events: none;
  }

  &:hover {
    cursor: pointer;

    #icon-above-image {
      transform: scale(1.15);
    }
  }
`
